<template>
  <div>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="row g-3 align-items-end">

          <div class="col-md-5" v-if="user.role_id && user.role_id == 3">
            <label class="form-label fw-semibold small text-muted mb-1">Livreur</label>
            <v-select
              class="custom-select-height"
              label="name"
              :options="LivreursList"
              v-model="liv_filter"
              placeholder="Tous les livreurs"
            />
          </div>

          <div class="col-md-5">
            <label class="form-label fw-semibold small text-muted mb-1">Statut</label>
            <select class="form-control form-select" v-model="status_filter" style="height:38px;">
              <option value="">Tous les statuts</option>
              <option :value="0">Nouveau</option>
              <option :value="1">Enregistré</option>
              <option :value="2">Payé</option>
            </select>
          </div>

          <!-- <div class="col-md-2">
            <label class="form-label fw-semibold small text-muted mb-1">Date de début</label>
            <input
              type="date"
              class="form-control"
              v-model="date_from"
              style="height:38px;"
            />
          </div>

          <div class="col-md-2">
            <label class="form-label fw-semibold small text-muted mb-1">Date de fin</label>
            <input
              type="date"
              class="form-control"
              v-model="date_to"
              :min="date_from"
              style="height:38px;"
            />
          </div> -->

          <div class="col-md-2 d-flex gap-2">
            <button class="btn btn-primary flex-grow-1" @click="filter()">
              <i class="flaticon-search me-1"></i> 
            </button>
            <button
              class="btn btn-outline-secondary"
              @click="Removefilter()"
              title="Réinitialiser les filtres"
            >
              <i class="flaticon-close"></i>
            </button>
          </div>

        </div>
      </div>
    </div>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="d-flex justify-content-end mb-15">
        <router-link
          class="btn btn-primary"
          v-if="user.role_id && user.role_id == 4 && auth.can('ADD_BP_L')"
          :to="{ name: 'NewPaymentPage' }"
        >
          <i class="flaticon-add me-1"></i> Ajouter Bon pour Livreur
        </router-link>
        <router-link
          class="btn btn-primary"
          v-if="user.role_id && user.role_id == 3 && auth.can('ADD_BP_L')"
          :to="{ name: 'NewPaymentModPage' }"
        >
          <i class="flaticon-add me-1"></i> Ajouter Bon pour Livreur
        </router-link>
      </div>

      <vue-good-table
        :select-options="{
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Bons Sélectionés',
          disableSelectInfo: true,
        }"
        @selected-rows-change="selectPays"
        @select-all="onSelectAllPays"
        :columns="columns"
        :rows="rows"
        responsive
      >
        <template #emptystate>
          <div class="text-center py-20 text-muted">Aucune entrée correspondante trouvée</div>
        </template>
        <template v-slot:table-row="props">
          <span v-if="props.column.field === 'note_ref'" class="text-nowrap">
            <b>{{ props.row.note_ref }}</b>
          </span>

          <span
            v-else-if="props.column.field === 'zone_name'"
            class="text-nowrap"
          >
            {{ props.row.zone_name }}<br/>
            {{ props.row.agency_name }}
          </span>

          <span
            v-else-if="props.column.field === 'created_at'"
            class="text-nowrap"
          >
            <template v-if="props.row.created_at != null">
              {{ getDate(props.row.created_at) }}<br/>
            </template>
            {{ props.row.by_name }}
          </span>
          <span v-else-if="props.column.field === 'total'" class="text-nowrap">
            {{ props.row.total }}
            {{ $devis }}
          </span>
          <!-- <span
            v-else-if="props.column.field === 'note_saved_time'"
            class="text-nowrap"
          >
            <h5 v-if="props.row.note_saved_time!=null">{{ getDate(props.row.note_saved_time) }}</h5>
            <center><span>{{props.row.note_saved_by_name}}</span></center>
          </span> -->

          <span v-else-if="props.column.field === 'receipts_count'" class="text-nowrap">
            <span v-if="props.row.statut == 2 && props.row.receipts_count > 0" class="badge rounded-pill fs-13 text-bg-success">
              {{ props.row.receipts_count }}
            </span>
            <span v-else-if="props.row.statut == 2" class="text-muted">Aucun</span>
            <span v-else class="text-muted">-</span>
          </span>

          <template v-else-if="props.column.field === 'statut'">
            <span
              v-if="props.row.statut == 0"
              class="badge rounded-pill fs-13 text-bg-danger"
            >
              Nouveau
            </span>
            <span
              v-else-if="props.row.statut == 1"
              class="badge rounded-pill fs-13 text-bg-info"
            >
              Enregistré
            </span>
            <span
              v-else-if="props.row.statut == 2"
              class="badge rounded-pill fs-13 text-bg-success"
            >
              Payé
            </span>
          </template>
          <template v-else-if="props.column.field === 'action'">
            <div class="dropdown">
              <button
                class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                :id="'dropdownMenuButton-' + props.row.id"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-more"></i>
              </button>
              <ul class="dropdown-menu dropdown-menu-end" :aria-labelledby="'dropdownMenuButton-' + props.row.id">
                <li v-if="auth.can('BP_L')">
                  <a class="dropdown-item" href="#" @click.prevent="openNewWindow(`/edit-payment-note/ref/${props.row.note_ref}`)">
                    <i class="flaticon-eye me-2"></i>
                    Détails du Bon
                  </a>
                </li>
                <li v-if="props.row.statut == 2 && user.role_id == 4">
                  <a class="dropdown-item" href="#" @click.prevent="openNewWindow(`/edit-payment-note/ref/${props.row.note_ref}`)">
                    <i class="flaticon-add me-2"></i>
                    Ajouter un reçu de paiement
                  </a>
                </li>
                <!-- 
                <li v-if="props.row.statut == 0 && props.row.total_parcel != 0 && auth.can('BP_L')">
                  <a class="dropdown-item" href="#" @click.prevent="SaveBon(props.row)">
                    <i class="flaticon-save me-2"></i>
                    Enregistrer le bon
                  </a>
                </li>
                <li v-if="props.row.statut == 1 && props.row.total_parcel != 0 && auth.can('BP_L')">
                  <a class="dropdown-item" href="#" @click.prevent="OpenBon(props.row)">
                    <i class="flaticon-unlock me-2"></i>
                    Ouvrir le bon
                  </a>
                </li>
                <li v-if="props.row.statut == 1 && props.row.total_parcel != 0 && props.row.total > 0 && auth.can('BP_L') && auth.can('PAID_BP_L')">
                  <a class="dropdown-item" href="#" @click.prevent="showModalPaid(props.row)">
                    <i class="flaticon-dollar-sign me-2"></i>
                    Changer En Payé
                  </a>
                </li> -->
                <li v-if="props.row.statut == 0 && props.row.total_parcel == 0 && auth.can('BP_L')">
                  <a class="dropdown-item" href="#" @click.prevent="RemoveNote(props.row)">
                    <i class="flaticon-trash me-2"></i>
                    Supprimer le Bon
                  </a>
                </li>
                <li v-if="props.row.total_parcel != 0">
                  <a class="dropdown-item" href="#" @click.prevent="GetPDF(props.row)">
                    <i class="flaticon-download me-2"></i>
                    Télécharger le bon
                  </a>
                </li>
                <!-- <li>
                  <a class="dropdown-item" href="#" target="_blank" title="Groupe Whatsapp">
                    <i class="flaticon-message me-2"></i>
                    Groupe Whatsapp
                  </a>
                </li> -->
              </ul>
            </div>
          </template>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <PaginatorContent
        :pagination="users"
        :offset="9"
        @paginate="getRecords"
      />
      </div>
    </div>

    <!-- <b-modal id="modal_PaidBox" :title="'Paiment Bon' + form.note_ref" cancel-variant="outline-secondary" size="lg"
      ok-title="Payé" cancel-title="Annuler" @ok="BonPaid">
      <div class="row">
        <div class="col-md-12">
          <span>Montant à payé: <b>{{ form.total }}</b></span>
        </div>

        <div class="col-md-12">
          <hr />
        </div>

        <div class="col-md-12">
          <div class="form-group" label="Montant payé" label-for="price">
            <input type="number" min="0" id="price" v-model="pricePaid" placeholder="Montant Payé" />
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group" label="Choisir la caisse :" label-for="caisse">
            <v-select :options="Caisses" v-model="caisse" label="name" >
             
            </v-select>
          </div>
        </div>
      </div>
    </b-modal> -->
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import { ref, reactive } from "vue";
import { useAuthStore } from "@/stores/auth";
import moment from "moment";
import api from "@/utils/axios";
import { useAppToast } from "@/composables/useAppToast";
import Swal from "sweetalert2";
export default defineComponent({
  setup() {

    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    const isLoader = ref(false);
    const load = ref(false);
    const pageLength = ref(10);
    const loading = ref(false);
    const searchTerm = ref("");
    const columns = [
        { label: "Référence", field: "note_ref" },
        { label: "Date de création", field: "created_at" },
        { label: "Zone", field: "zone_name" },
        { label: "Livreur", field: "for_name" },
        { label: "Statut", field: "statut" },
        { label: "Colis", field: "total_parcel" },
        { label: "Total", field: "total" },
        { label: "Reçus", field: "receipts_count" },
        { label: "Actions", field: "action", width: "180px" },
    ];
    const rows = ref([]);
    const LivreursList = ref([]);
    const ZonesList = ref([]);
    const CuserList = ref([]);
    const zone_filter = ref({ id: "", name: "" });
    const liv_filter = ref({ id: "", name: "" });
    const created_filter = ref({ id: '', name: '' });
    const status_filter = ref("");
    const date_from = ref("");
    const date_to = ref("");
    const users = reactive({
        searchTerm: "",
        searchZone: "",
        searchLiv: "",
        searchStatut: "",
        searchSDate: "",
        searchEDate: "",
        searchUser: "",
        total: 0,
        per_page: 10,
        from: 1,
        to: 0,
        current_page: 1,
    });
    const offset = ref(9);
    const row_ref = ref({});
    const pricePaid = ref("");
    const form = reactive({
        id: 0,
        note_ref: "",
        total: "",
    });
    const Caisses = ref([]);
    const caisse = ref<{ id?: string | number; name?: string }>({});
    const selectedPays = ref([]);
    const showTotal = ref(false);
    const total = ref('');

    const debounceTimer = ref(null);

    function onSearchZones(search, loading) {
      if (search.length && ZonesList.value.length === 0) {
        loading(true);
        api
          .get(`/api/auth/ListZone`)
          .then((response) => {
            ZonesList.value = response.data;
            ZonesList.value.unshift({ id: "", name: "Tous" });
            loading(false);
          });
      }
    }

    function onSearchCaisses(search, loading) {
      if (search.length && Caisses.value.length === 0) {
        loading(true);
        api
          .get(`/api/auth/ListCaisse`)
          .then((response) => {
            Caisses.value = response.data;
            loading(false);
          });
      }
    }

    function getDate(value) {
      return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
    }

    function resolveUserStatusVariant(status) {
      if (status === 0) return "danger";
      if (status === 1) return "info";
      if (status === 2) return "success";
      return "warning";
    }

    function showModalPaid(row) {
      form.id = 0;
      form.note_ref = "";
      form.total = "";
      caisse.value = {};
      pricePaid.value = "";
      form.id = row.id;
      form.note_ref = row.note_ref;
      form.total = row.total;
    }

    function convert(str) {
      const date = new Date(str);
      const mnth = ("0" + (date.getMonth() + 1)).slice(-2);
      const day = ("0" + date.getDate()).slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    }

    function filter() {
      users.searchZone = zone_filter.value.id;
      users.searchLiv = liv_filter.value.id;
      users.searchStatut = status_filter.value;
      users.searchUser = created_filter.value.id;
      users.searchSDate = date_from.value ?? "";
      users.searchEDate = date_to.value ?? "";
      users.searchTerm =
        users.searchTerm !== "undefined" ? users.searchTerm : "";
      users.current_page = 1;
      getRecords();
    }

    function Removefilter() {
      users.searchZone = "";
      users.searchUser = "";
      searchTerm.value = "";
      users.searchLiv = "";
      users.searchStatut = "";
      users.searchTerm = "";
      status_filter.value = "";
      users.searchSDate = "";
      users.searchEDate = "";
      date_from.value = "";
      date_to.value = "";
      zone_filter.value = { id: "", name: "" };
      liv_filter.value = { id: "", name: "" };
      created_filter.value = { id: "", name: "" };
      users.current_page = 1;
      getRecords();
    }

    function handleInput() {
      if (debounceTimer.value) clearTimeout(debounceTimer.value);
      debounceTimer.value = setTimeout(() => {
        if (!searchTerm.value || searchTerm.value === "") {
          users.searchTerm = searchTerm.value;
          filter();
        } else if (searchTerm.value && searchTerm.value.length > 2) {
          users.searchTerm = searchTerm.value;
          filter();
        }
      }, 500);
    }

    function getRecords(page = 1) {
      users.current_page = page;
        isLoader.value = true;
      api
        .get(
          `/api/auth/payment_liv_list?searchTerm=${users.searchTerm}&searchZone=${users.searchZone}&searchUser=${users.searchUser}&searchLiv=${users.searchLiv}&searchStatut=${users.searchStatut}&searchSDate=${users.searchSDate}&searchEDate=${users.searchEDate}&page=${users.current_page}&per_page=${users.per_page}`
        )
        .then((response) => {
          rows.value = response.data.users.data;
          Object.assign(users, response.data.users);
          isLoader.value = false;
        });
      
    }
    onMounted(() => {
      getRecords();
      // onSearchZones("", (v) => v);
      // onSearchCaisses("", (v) => v);
    });

    function DestroyBrc(brc) {
      const data = new FormData();
      data.append("reception_note_id", brc.id);
      data.append("cstmr_id", brc.note_customer);
      // api.post(`/api/auth/DestroyBrc`, data)
    }

    function showModal(row) {
      row_ref.value = row.note_ref;
    }

    function SaveBon(row) {
      Swal
        .fire({
          text: "Vous voulez enregistrer ce bon ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Oui, enregistrer!",
        })
        .then((result) => {
          if (result.value) {
            api
              .post(`/api/auth/save_bp/${row.id}`)
              .then((res) => {
                if (res.data.message === "success") {
                  filter();
                } else if (
                  res.data.message === "not exist" ||
                  res.data.message === "no parcel"
                ) {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Vous pouvez pas enregistré ce bon",
                  });
                } else {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Un erreur ! ",
                  });
                }
              })
              .catch(() => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong! Pleaz try again",
                });
              });
          }
        });
    }

    function OpenBon(row) {
      api
        .post(`/api/auth/unsave_bp/${row.id}`)
        .then((res) => {
          if (res.data.message === "success") {
            filter();
          } else if (
            res.data.message === "not exist" ||
            res.data.message === "no parcel"
          ) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Vous pouvez pas ouvrir ce bon",
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Un erreur ! ",
            });
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong! Pleaz try again",
          });
        });
    }

    function BonPaid(row) {
      if (
        !pricePaid.value ||
        pricePaid.value == null ||
        pricePaid.value === "" ||
        Number(form.total) < Number(pricePaid.value) ||
        Object.keys(caisse.value).length === 0
      ) {
        showToast(
          "Champs obligatoire, Merci de remplir tous les champs",
          "error"
        );
      } else {
        const data = new FormData();
        data.append("note_ref", form.note_ref);
        data.append("note_id", form.id.toString());
        data.append("amount", pricePaid.value);
        data.append("caisse_id", String(caisse.value.id));
        data.append("caisse_name", caisse.value.name);
        api
          .post(`/api/auth/Paid_bp`, data)
          .then((res) => {
            if (res.data.message === "success") {
              filter();
            } else if (
              res.data.message === "not exist" ||
              res.data.message === "no parcel"
            ) {
              showToast(
                "Vous pouvez pas payé ce bon",
                "error"
              );
            } else {
              showToast(
                "Un erreur ! ",
                "error"
              );
            }
          })
          .catch(() => {
            showToast(
              "Something went wrong! Pleaz try again",
              "error"
            );
          });
      }
    }

    function GetPDF(row) {
      api
        .get(`/api/auth/PAYMPDF/${row.id}`, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          window.open(link.href, "_blank");
        });
    }

    function RemoveNote(row) {
      Swal
        .fire({
          text: "Vous voulez supprimer ce bon ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Oui, supprimer!",
        })
        .then((result) => {
          if (result) {
            api
              .post(`/api/auth/remove_pay_note/${row.id}`)
              .then((res) => {
                if (res.data.message === "success") {
                  filter();
                  showToast(
                    "Bon est bien supprimé",
                    "success"
                  );
                } else if (
                  res.data.message === "error note" ||
                  res.data.message === "no data"
                ) {
                  showToast(
                    "Vous pouvez pas supprimer ce bon",
                    "error"
                  );
                }
              });
          }
        });
    }

    function fetchLivs(zone) {
      if (zone && Object.keys(zone).length !== 0) {
        api
          .get(`/api/auth/LivsZone/${zone.id}`)
          .then((res) => {
            LivreursList.value = res.data;
            LivreursList.value.unshift({ id: "", name: "Tous" });
          });
      }
    }

    function onSearchUsers(search, loading) {
      if (search.length && CuserList.value.length === 0) {
        loading(true);
        api
          .get(`/api/auth/SelectList`)
          .then((response) => {
            CuserList.value = response.data;
            CuserList.value.unshift({ id: "", name: "Tous" });
            loading(false);
          });
      }
    }

    function openNewWindow(url) {
      window.open(url, "_blank");
    }

    function selectPays(params) {
      selectedPays.value = params.selectedRows;
    }

    function onSelectAllPays(params) {
      selectedPays.value = params.selectedRows;
    }

    function handelTotal(x) {
      showTotal.value = false;
      if (x === 0) {
        if (!selectedPays.value || selectedPays.value.length === 0) {
          showToast(
            "Vous devez sélectionner au moins un bon pour calculer le total",
            "error"
          );
        } else {
          const data = new FormData();
          const payIds = [];
          for (let j = 0; j < selectedPays.value.length; ++j) {
            payIds.push(selectedPays.value[j].id);
          }
          data.append("payIds", JSON.stringify(payIds));
          data.append("type", "list");
          load.value = true;
          api
            .post(`/api/auth/handelTotal`, data)
            .then((res) => {
              load.value = false;
              if (res.data.success) {
                total.value = res.data.total;
                showTotal.value = true;
                showToast(
                  "Total est bien calculé",
                  "success"
                );
              } else {
                showToast(
                  res.data.message,
                  "error"
                );
              }
            })
            .catch(() => {
              showToast(
                "Something went wrong! Pleaz try again",
                "error"
              );
            });
        }
      } else if (x === 1) {
        const data = new FormData();
        data.append("type", "all");
        load.value = true;
        api
          .post(`/api/auth/handelTotal`, data)
          .then((res) => {
            load.value = false;
            if (res.data.success) {
              total.value = res.data.total;
              showTotal.value = true;
              showToast(
                "Total est bien calculé",
                "success"
              );
            } else {
              showToast(
                res.data.message,
                "error"
              );
            }
          })
          .catch(() => {
            showToast(
              "Something went wrong! Pleaz try again",
              "error"
            );
          });
      }
    }


    return {
        date_from,
        date_to,
        isLoader,
        load,
        pageLength,
        loading,
        searchTerm,
        columns,
        rows,
        LivreursList,
        ZonesList,
        CuserList,
        zone_filter,
        liv_filter,
        created_filter,
        status_filter,
        users,
        offset,
        row_ref,
        pricePaid,
        form,
        Caisses,
        caisse,
        selectedPays,
        showTotal,
        total,

        onSearchZones,
        onSearchCaisses,
        getDate,
        resolveUserStatusVariant,
        showModalPaid,
        convert,
        filter,
        Removefilter,
        handleInput,
        getRecords,
        DestroyBrc,
        showModal,
        SaveBon,
        OpenBon,
        BonPaid,
        GetPDF,
        RemoveNote,
        fetchLivs,
        onSearchUsers,
        openNewWindow,
        selectPays,
        onSelectAllPays,
        handelTotal,
        auth,
        user,
    };
  },
});
</script>
